/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import {FETCH_SUBMISSIONS_REQUEST, FETCH_SUBMISSIONS_SUCCESS, FETCH_SUBMISSIONS_FAILURE} from './ApplicationDetailsSubmissionsTypes';

const initialState = {
    loading: false,
    submissions: [],
    error: "",
  };

    const submissionsReducer = (state = initialState, action) => {
      switch (action.type) {
        case FETCH_SUBMISSIONS_REQUEST:
            return {
              ...state,
              loading: true,
            };
          
        case FETCH_SUBMISSIONS_SUCCESS:
          return {
            loading: false,
            submissions: action.payload,
            error: "",
          };
        case FETCH_SUBMISSIONS_FAILURE:
          return {
            loading: false,
            submissions: [],
            error: action.payload,
          };
        default:
          return state;
      }
    };

export default submissionsReducer;
  